import React from 'react';
import { Handle, NodeProps, Position } from 'reactflow';

import { Box } from '@mui/material';

import CustomTooltip from '../../common/CustomTooltip';
import styles from './NodeTypes.module.css';

const RequestNode: React.FC<NodeProps> = ({ id, data }) => {
    return (
        <CustomTooltip title="Click to work with request schema">
            <Box className={`${styles.node} ${styles.requestNode}`}>
                {data.label}

                <Handle
                    className={styles.handle}
                    type="target"
                    position={Position.Top}
                    isConnectable={false}
                />
                <Handle
                    // className={styles.handle}
                    style={{ background: '#bbb ' }}
                    type="source"
                    position={Position.Bottom}
                    isConnectable={false}
                />
            </Box>
        </CustomTooltip>
    )
}

export default RequestNode